<template>
	<div style="background-color: #F2F2F2;">
		<v-layout column justify-center align-center style="min-height: 100vh" >
			<v-flex xs12 sm8 md6>
				<div class="text-center my-1">
						<v-img width="400" src='/static/images/404.png' />
				</div>
				<div class="text-center my-1">
						<v-btn class="ma-2" tile outlined color="grey" :to="{ name: 'Index', params: { id: '1589756239' } }">
							<v-icon left>mdi-comment-alert-outline</v-icon> Ir a Inicio
						</v-btn>
				</div>

			</v-flex>
		</v-layout>
	</div>
</template>

<script>
	export default {
		name: 'NotFound'
	}
</script>
//F2F2F2